import { render } from "./Sidebar.vue?vue&type=template&id=b01c4b82&scoped=true"
import script from "./Sidebar.vue?vue&type=script&lang=js"
export * from "./Sidebar.vue?vue&type=script&lang=js"

import "./Sidebar.vue?vue&type=style&index=0&id=b01c4b82&lang=scss"
import "./Sidebar.vue?vue&type=style&index=1&id=b01c4b82&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-b01c4b82"

export default script